<template>
  <div>
    <div class="search fb fb-main-start fb-cross-center">
      <div
        class="search-box font-30 item-flex-1 fb fb-main-start fb-cross-center"
      >
        <i class="iconfont mr-10 c-171A1D-56 font-28">&#xe66d;</i>
        <input
          ref="input"
          type="text"
          v-model="searchValue"
          :placeholder="placeholder"
          @focus="handlerFocus"
          @blur="handlerBlur"
        />
        <span
          @click="handlerToClearSearchKey"
          class="iconfont c-171A1D-40 ml-10"
          v-if="!showSelect && searchValue"
          >&#xe6f5;</span
        >
      </div>
      <div
        class="search-tool font-34"
        :class="$store.getters.selectedClass ? 'c-171A1D' : 'c-006AFE'"
        v-if="showSelect && !searchValue"
      >
        <span v-if="!searchValue" @click="handlerToSetFilterCondition">
          <i class="iconfont">&#xe6f4;</i>
          筛选
        </span>
        <!-- <span v-else @click="handlerToClearSearchKey">取消</span> -->
      </div>
    </div>
  </div>
</template>
<script>
import { RETURN_TYPE } from '@/utils/constUtils'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  props: {
    curRole: {
      type: Number,
      default: 0
    },
    appointRole: {
      type: [Number, String],
      default: 0
    },
    link: {
      type: String,
      default: ''
    },
    searchKey: {
      type: String,
      default: ''
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '搜索姓名'
    },
    onlyClass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchValue: this.searchKey
    }
  },
  watch: {
    searchKey(v) {
      this.searchValue = v
    },
    searchValue() {
      this.handlerChangeSearchKey()
    }
  },
  methods: {
    handlerFocus() {
      this.$emit('focus')
    },
    handlerBlur() {
      this.$emit('blur')
    },
    handlerChangeSearchKey() {
      this.$emit('update:searchKey', this.searchValue)
    },
    handlerToSetFilterCondition() {
      if (this.onlyClass) {
        // 选择班级
        let _mSchoolAddressBook = {
          addressType: 2,
          role: this.currentRole,
          appointRole: this.appointRole,
          userId: this.dingUserId,
          corpId: this.corpId,
          appId: this.appId,
          corpName: this.corpName,
          selectType: 3,
          returnType: RETURN_TYPE.dingNode, // 返回魔点Id
          classList: this.classList,
          multiple: false,
          campus: this.$store.getters.currentCapmus,
          canViewDetail: false
        }
        this.$addressList(_mSchoolAddressBook)
          .then(res => {
            if (res) {
              this.$store.commit('selectedClass', {
                selectedClassTpId: res
              })
            } else {
              this.$store.commit('selectedClass', null)
            }

            this.$emit('chooseClass')
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        let _query = this.$route.query
        _query.curRole = this.currentMixinRole
        this.$router.push({ path: this.link, query: _query })
      }
    },
    handlerToClearSearchKey() {
      this.searchValue = ''
      this.$refs.input.blur()
      this.$emit('update:searchKey', this.searchValue)
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.search {
  height: 52px;
  min-height: 52px;
  padding: 0 8px;
  background: #ffffff;

  > .search-box {
    height: 36px;
    padding: 13px;
    border-radius: 99999px;
    background: rgba(#191f25, 0.08);

    > input {
      width: 100%;
      background: none;

      &:focus {
        border: none;
        outline: none;
      }
    }
  }

  > .search-tool {
    margin-left: 16px;
    width: 60px;
    text-align: right;
  }
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: rgba(#191f25, 0.4) !important;
}
</style>
